<template>
    <FormField
        :recordable-type="recordableType"
        :recordable-id="recordableId"
        :unique-constraint-show-url="uniqueConstraintShowUrl"
        :merge-search-url="mergeSearchUrl"
        :merge-label="mergeLabel"
        :field="field"
        :value="data[name(field)]"
        v-slot="props"
    >
        <div class="flex items-center space-x-2">
            <component
                :is="lookupComponent(field)"
                v-model="data[name(field)]"
                :values="data"
                :field="field"
                @blur="props.blur()"
                @hide="props.hide()"
                data-component
                class="w-full"
            />
            <slot name="field-addon" v-bind:field="field" />
        </div>
    </FormField>
</template>

<script>
import * as Form from '@App/Utils/Form'
import FormField from './FormField.vue'
import FieldBrazilianAddress from './Fields/BrazilianAddress.vue'
import FieldButton from './Fields/Button.vue'
import FieldDate from './Fields/Date.vue'
import FieldInput from './Fields/Input.vue'
import FieldNumeric from './Fields/Numeric.vue'
import FieldSelect from './Fields/Select.vue'
import FieldSelectCheckbox from './Fields/SelectCheckbox.vue'
import FieldSelectRadio from './Fields/SelectRadio.vue'
import FieldWhatsappNumber from './Fields/WhatsappNumber.vue'
import FieldEmail from './Fields/Email.vue'
import FieldTextarea from './Fields/Textarea.vue'
import FieldUploadSingleFile from './Fields/UploadSingleFile.vue'
import FieldUploadMultipleFiles from './Fields/UploadMultipleFiles.vue'
import FieldProductsAndTicketReasons from './Fields/ProductsAndTicketReasons.vue'
import FieldHtml from './Fields/Html.vue'
import FieldPhoneNumber from './Fields/PhoneNumber.vue'
import FieldPuzzlePieces from './Fields/PuzzlePieces.vue'

export default {
    props: [
        'field',
        'data',
        'value',
        'recordableType',
        'recordableId',
        'uniqueConstraintShowUrl',
        'mergeSearchUrl',
        'mergeLabel',
    ],
    components: {
        FormField,
    },
    methods: {
        name(field) {
            return Form.name(field)
        },

        lookupComponent(field) {
            return {
                brazilian_address: FieldBrazilianAddress,
                button: FieldButton,
                date: FieldDate,
                text: FieldInput,
                numeric: FieldNumeric,
                number: FieldNumeric,
                whatsapp_jid: FieldWhatsappNumber,
                select: FieldSelect,
                select_checkbox: FieldSelectCheckbox,
                checkboxes: FieldSelectCheckbox,
                select_radio: FieldSelectRadio,
                email: FieldEmail,
                textarea: FieldTextarea,
                single_file: FieldUploadSingleFile,
                multiple_files: FieldUploadMultipleFiles,
                products_and_ticket_reasons: FieldProductsAndTicketReasons,
                html: FieldHtml,
                phone_number: FieldPhoneNumber,
                puzzle_pieces: FieldPuzzlePieces,
            }[Form.type(field)]
        },
    },
}
</script>